import React, { useContext, useMemo } from 'react';
import { shallowEqual, useSelector } from 'umi'
import { FilterContext } from "@/pages/dashboard/components/PageContainer/context";
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import KeyMetrics from './KeyMetrics';
import { PERIODTIMEOBJ } from '@/pages/dashboard/_config/constant';
import './index.scss';

export default function NightingaleKeyMetricsService(props: any) {
  const { style, className, type, config, ...resetProps } = props || {}
  const { api, mainMetricsList = [], metricsList = [], isDark = false, haveJump = false, height = 460,
    isChangeHeight = 424,refreshKey='', interval } = config || {}
  const contextObj = useContext(FilterContext)
  const { filterVal, filterLoading } = contextObj || {};

  const { gameCode } = useSelector((state: any) => {
    return {
      gameCode: state?.dashboard?.currentGame?.game_code,
    }
  }, shallowEqual)

  const data = useMemo(() => {
    return {
      gameCode,
      metricsList,
      mainMetricsList,
      isDark,
      haveJump,
      height,
      isChangeHeight,
    }
  }, [gameCode, metricsList, mainMetricsList, isDark, haveJump, height, isChangeHeight])

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        refreshKey={refreshKey}
        interval={interval}
        dataKey={'keyMetricsData'}
        beforeRequest={(data) => {
          const { filterVal, gameCode } = data;
          const { timeType, diff, rangeTime, ...filters } = filterVal || {};
          const params = {
            game_code: gameCode,
            period: PERIODTIMEOBJ?.[timeType],
            filters: formatFilterValues(filters),
            start_time: rangeTime?.[0],
            end_time: rangeTime?.[1],
            is_confirm: true,
            metrics: metricsList,
            trend_metrics: mainMetricsList
          };
          return params
        }}
        trackData={['gameCode', 'metricsList', 'mainMetricsList', 'isDark']}>
        <KeyMetrics {...resetProps}></KeyMetrics>
      </Service>
    </div>
  );
};
